'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {

    CHANGE: 'FACETS_CHANGE',

    UPDATE: 'FACETS_UPDATE',
    REPLACE: 'FACETS_REPLACE'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/facets/action-types.js
// module id = 587
// module chunks = 0